
<script>
    export let article;
  </script>
  
  <div class="article">
    <img src={article.image} alt={article.title}>
    <h2>{article.title}</h2>
    <p>{article.content}</p>
  </div>
  
  <style>
    .article {
      width: 30%;
      margin-bottom: 20px;
      background-color: #1a1a1a;
      border: 1px solid #00ffff;
      padding: 10px;
      transition: all 0.3s ease;
    }
  
    .article:hover {
      transform: scale(1.05);
      box-shadow: 0 0 15px #00ffff;
    }
  
    .article img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  
    .article h2 {
      color: #ff00ff;
      margin-top: 10px;
    }
  
    .article p {
      color: #00ff00;
    }
  
    @media (max-width: 768px) {
      .article {
        width: 100%;
      }
    }
  </style>
  